import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWorkflow } from "../workflowModel";

export const getAllWorkflows = createAsyncThunk(
  "WorkFlow/FindAllWorkFlow",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/FindAllWorkFlow`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Workflows:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWorkflow = createAsyncThunk(
  "WorkFlow/InsertWorkFlow",
  async (WorkflowData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/InsertWorkFlow`,
        WorkflowData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Workflow:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWorkflow = createAsyncThunk(
  "WorkFlow/UpdateWorkFlow",
  async (WorkflowData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/UpdateWorkFlow`,
        WorkflowData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Workflow:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWorkflow = createAsyncThunk(
  "WorkFlow/DeleteWorkFlow",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/DeleteWorkFlow`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Workflow :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWorkflowByID = createAsyncThunk(
  "WorkFlow/FindByIDWorkFlow",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/FindByIDWorkFlow`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Title: result?.Title,
        ShortDescription: result?.ShortDescription,
        LongDescription: result?.LongDescription,
        SequenceNo: result?.SequenceNo,
        MainImage: result?.MainImage,
        OtherImage: result?.OtherImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IWorkflow;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Workflow :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWorkflows = createAsyncThunk(
  "WorkFlow/FindAllActiveWorkFlow",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WorkFlow/FindAllActiveWorkFlow`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Workflows:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWorkflow = createAsyncThunk(
  "WorkFlow/ActiveInActiveWorkFlow",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/ActiveInActiveWorkFlow`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Workflow :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD
export const WorkflowDetailsImageUpload = createAsyncThunk(
  "WorkFlow/WorkFlowImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkFlow/WorkFlowImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Workflow Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
